export const isPageTwoAndOneDoctor = (steps, doctors) => {
  const condition = steps === 2 && doctors?.length === 1;

  return condition;
};
